setTimeout(function(){
jQuery("#klaviyo-bis-iframe").on("load", function() {
  var head = jQuery("#klaviyo-bis-iframe").contents().find("head");
  var css = '<style>.btn{text-transform:uppercase;font-size:13px;font-weight:normal;letter-spacing:0.3em;}h3.modal-title{font-size:19.55px;}p{font-size:13px;}</style>';
  jQuery(head).append(css);
});
}, 700);

$(document).ready(function() {
  // cartdrawer featured collection slider
  $('.featured_slider_cart').slick({
      infinite: true,
      centerMode: false,
      slidesToShow: 2, // Shows a three slides at a time
      slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
      arrows: true, // Adds arrows to sides of slider
      dots: false, // Adds the dots on the bottom
  });
});
$(".js-drawer-open-cart").on("click",function(){
     $('.featured_slider_cart').slick('unslick');
      $('.featured_slider_cart').slick({
      infinite: true,
      centerMode: false,
      slidesToShow: 2, // Shows a three slides at a time
      slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
      arrows: true, // Adds arrows to sides of slider
      dots: false, // Adds the dots on the bottom
     
    });
});
window.addEventListener('load', (event) => {

  const aisButton = document.querySelector('.ais-facets-button');
  const facetContainer = document.querySelector('#palgolia-sidebar-container');

  if(aisButton != null){
  	aisButton.onclick = function() {
      facetContainer.classList.toggle('active');
    }
  }
});

$(document).ready(function() {
$('.logo-bar').slick({
  dots: false,
  infinite: true,
  slidesToShow: 6,
  slidesToScroll: 1,
  adaptiveHeight: true,
  autoplay: true,
  autoplaySpeed: 4000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});
});  
$(document).ready(function(){
    setTimeout(function(){
      if(!$('.featured_slider').hasClass('slick-initialized'))
      {
        $('.featured_slider').slick({
          infinite: true,
          centerMode: false,
          slidesToShow: 5, // Shows a three slides at a time
          slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
          arrows: true, // Adds arrows to sides of slider
          dots: false, // Adds the dots on the bottom
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
                infinite: true,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }
          ]
        });
      }
       
      if(!$('.featured_slider_second_section').hasClass('slick-initialized'))
      {
        $('.featured_slider_second_section').slick({
          infinite: true,
          centerMode: false,
          slidesToShow: 4, // Shows a three slides at a time
          slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
          arrows: true, // Adds arrows to sides of slider
          dots: false, // Adds the dots on the bottom
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    },1);

  if ($(window).width() < 767){

    function recommendationsSlider() {
      if(!$('.product-recommendations .grid').hasClass('slick-initialized'))
      {
        $('.product-recommendations .grid').slick({
          infinite: true,
          centerMode: false,
          slidesToShow: 4, // Shows a three slides at a time
          slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
          arrows: true, // Adds arrows to sides of slider
          dots: false, // Adds the dots on the bottom
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    }

    function recentlySlider() {
      if(!$('#RecentlyViewed-recently-viewed').hasClass('slick-initialized'))
      {
        $('#RecentlyViewed-recently-viewed').slick({
          infinite: true,
          centerMode: false,
          slidesToShow: 4, // Shows a three slides at a time
          slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
          arrows: true, // Adds arrows to sides of slider
          dots: false, // Adds the dots on the bottom
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    }
    
    var timer = setInterval(function() {
      var recommendationsLength = $('.product-recommendations .grid-product').length;
      if (recommendationsLength > 2){
        recommendationsSlider();
        clearInterval(timer);
      } 
    }, 200);

    var recentlyTimer = setInterval(function() {
      var recentlyLength = $('#RecentlyViewed-recently-viewed .grid-product').length;
      if (recentlyLength > 2){
        recentlySlider();
        clearInterval(recentlyTimer);
      } 
    }, 200);

  }
  
});

$(document).ready(function() {
  $(document).on("click","#trigger",function(e) {
    e.preventDefault();
    
    var pdfLink = $(this).attr('href');
    $('#myModal').find('.modal-content img').attr('src',pdfLink);
    $('#myModal').show();
    
//     if ($(window).width() < 960) {
//       $("#dialog").dialog({
//         autoOpen: false,
//         maxWidth:300,
//         maxHeight: 250,
//         width: 300,
//         height: 250,
//         modal: true
//       });
//     }else{  
//       $("#dialog").dialog({
//         autoOpen: false,
//         maxWidth:900,
//         maxHeight: 900,
//         width: 900,
//         height: 900,
//         modal: true
//       });
//     }
    
// 	var pdfLink = $(this).attr('href');
//     $('#dialog').find('iframe').attr('src',pdfLink);
//     $("#dialog").dialog("open");

//     $("#dialog").dialog();
  }); 
}); 

// Get the modal
var modal = document.getElementById("myModal");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  modal.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}

$(document).on('click','.add-to--cart-button',function(e){
  e.preventDefault();
  var variant_id = $(this).closest('form').find('[name="id"]').val();
  var data = {
    "id": variant_id,
    "quantity": 1
  }
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(product) { 
      if ($('body').hasClass('template-cart')) {
        location.reload();
      }else{
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: $(this)
          }
        }));
      }
    }
  });
});

$(document).on('change','#minimal-packaging',function(){
    if(this.checked) {
      var isChecked = $('#gift-wrapping').is(':checked');
      if(isChecked){
        if($('.drawer-error').length > 0){
         $('.drawer-error').show();
        }else{
          $( "<p class='drawer-error'>You can only select one of the two options 'Minimal Packaging' OR 'Gift Packaging'</p>" ).insertBefore( "[data-discounts]" );
        }
        $(this).prop('checked', false);
        return false;
      }else{
        $('.drawer-error').remove();
      }
      var data = 'Yes';
      var qty = 1;
    }else{
      var data = '';
      var qty = 0;
    }

    var variantId = $(this).data('id');
    var submitData = { updates: {},attributes:{} };
    submitData.updates[variantId] = qty;
    // submitData.attributes['minimal-packaging'] = data;
  
    var headers = new Headers({ 'Content-Type': 'application/json' });
    var request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(submitData)
      };
  
    fetch('/cart/update.js', request)
    .then(function() {

      fetch('/cart?view=ajax').then(function(response) {
        return response.text();
      }).then(function(html) {
        // Convert the HTML string into a document object
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var subtotal = parseInt(doc.querySelector('.cart__items').getAttribute('data-cart-subtotal')) ; 
        var count = parseInt(doc.querySelector('.cart__items').getAttribute('data-count')) ;  
        var div = doc.querySelector('.cart__items');
        
        if(subtotal > 0 || count > 0){
          $('[data-products]').html(div);
          $('[data-subtotal]').html(theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat)); 	
        }else{
          $('#CartDrawer').addClass('is-empty');
          $("#CartBubble").hide();
          $('.shipping-savings-message').addClass('hide')
        } 

        // window.removePackagingProducts();
        
      });
    });  
});

$(document).on('change','#gift-wrapping',function(){
    if(this.checked) {
      var isChecked = $('#minimal-packaging').is(':checked');
      if(isChecked){
        if($('.drawer-error').length > 0){
          $('.drawer-error').show();
        }else{
          $( "<p class='drawer-error'>You can only select one of the two options 'Minimal Packaging' OR 'Gift Packaging'</p>" ).insertBefore( "[data-discounts]" );
        }
        $(this).prop('checked', false);
        return false;
      }else{
        $('.drawer-error').remove();
      }

    $(this).closest('#is-a-gift').find('.note-msg').show();
      var data = 'Yes';
      var qty = 1;
    }else{
      $(this).closest('#is-a-gift').find('.note-msg').hide();
      var data = '';
      var qty = 0;
    }

    $('#Product-gift-details').css('height','auto');

    var variantId = $(this).data('id');
    var submitData = { updates: {},attributes:{} };
    submitData.updates[variantId] = qty;
    submitData.attributes['gift-wrapping'] = data;

    console.log('submitData',submitData);
    var headers = new Headers({ 'Content-Type': 'application/json' });
    var request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(submitData)
      };

    fetch('/cart/update.js', request)
    .then(function() {

      fetch('/cart?view=ajax').then(function(response) {
        return response.text();
      }).then(function(html) {
        // Convert the HTML string into a document object
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var subtotal = parseInt(doc.querySelector('.cart__items').getAttribute('data-cart-subtotal')) ; 
        var count = parseInt(doc.querySelector('.cart__items').getAttribute('data-count')) ;  
        var div = doc.querySelector('.cart__items');
        
        if(subtotal > 0 || count > 0){
          $('[data-products]').html(div);
          $('[data-subtotal]').html(theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat)); 	
        }else{
          $('#CartDrawer').addClass('is-empty');
          $("#CartBubble").hide();
          $('.shipping-savings-message').addClass('hide')
        } 
        // window.removePackagingProducts();
      });
    });
});  

  // Get the modal
var typesmodal = document.getElementById("typesModal");

// Get the button that opens the modal
var typesbtn = document.getElementsByClassName("packaging-types");

// Get the <span> element that closes the modal
var typesspan = document.getElementsByClassName("drawermodalclose")[0];

// When the user clicks on the button, open the modal
$(document).on('click','.packaging-types',function(){
  $(typesmodal).show();
});

// When the user clicks on <span> (x), close the modal
typesspan.onclick = function() {
  typesmodal.style.display = "none";
}
$(window).click(function(e) {
  if(e.target.id == 'typesModal'){
      typesmodal.style.display = "none";
  }
});

function removeItem(key) {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: key,
      quantity: 0,
    },
  }).then((data) => {
    fetch('/cart?view=ajax').then(function(response) {
      return response.text();
    }).then(function(html) {
      if ($('body').hasClass('template-cart')) {
        location.reload();
      }else{
        // Convert the HTML string into a document object
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var subtotal = parseInt(doc.querySelector('.cart__items').getAttribute('data-cart-subtotal')) ; 
        var count = parseInt(doc.querySelector('.cart__items').getAttribute('data-count')) ;  
        var div = doc.querySelector('.cart__items');
        
        if(subtotal > 0 || count > 0){
          $('[data-products]').html(div);
          $('[data-subtotal]').html(theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat)); 	
        }else{
          $('[data-products]').html('');
          $('#CartDrawer').addClass('is-empty');
          $("#CartBubble").hide();
        } 
      }
    });
  });
}

$(document).on('click','.cart__remove a',function(e){
  e.preventDefault();
  var key = $(this).data('key');
  removeItem(key);
});

(function() {
  function trackScroll() {
    var scrolled = window.pageYOffset;
    var coords = document.documentElement.scrollHeight / 2;
    if (scrolled > coords) {
      goTopBtn.classList.remove('hide');
    }
    if (scrolled < coords) {
      goTopBtn.classList.add('hide');
    }
  }

  function backToTop() {
    // Use smooth scroll if supported
    if ('scrollBehavior' in document.documentElement.style) {
      console.log('A');
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      console.log('Else');
      // Fallback for older browsers
      smoothScrollFallback();
    }
  }

  function smoothScrollFallback() {
    if (window.pageYOffset > 0) {
      window.scrollBy(0, -80);
      setTimeout(smoothScrollFallback, 10);
    }
  }

  var goTopBtn;
  var checkInterval = setInterval(function() {
    goTopBtn = document.querySelector('.back-to-top');
    if (goTopBtn) {
      clearInterval(checkInterval);
      var pagination = document.querySelector('.ais-Pagination--noRefinement');
      console.log('pagination',pagination);
      if (pagination) {
        goTopBtn.classList.add('pagination-not-available');
      }
      window.addEventListener('scroll', trackScroll);
      goTopBtn.addEventListener('click', backToTop);
    }
  }, 1000); // Check every 1000 milliseconds (1 second)
})();

document.addEventListener("DOMContentLoaded", function () {
  const subCollectionList = document.querySelectorAll(".grid_item--subcollection_list");
  if(subCollectionList){
    subCollectionList.forEach(list => {
      if (list.scrollWidth > list.clientWidth) {
        list.classList.add("is-overflowing");
      } else {
        list.classList.remove("is-overflowing");
      }
    });
  }
});

$(document).ready(function () {
  function initSlider() {
    if ($(window).width() <= 768) {
      if (!$('.text-columns-with-images--slider').hasClass('slick-initialized')) {
        $('.text-columns-with-images--slider').slick({
          dots: false,
          infinite: true,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: false,
          prevArrow: `<button type="button" class="slick-prev">
                        <svg class="flickity-button-icon" viewBox="0 0 100 100">
                          <path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path>
                        </svg>
                      </button>`,
          nextArrow: `<button type="button" class="slick-next">
                        <svg class="flickity-button-icon" viewBox="0 0 100 100">
                          <path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180)"></path>
                        </svg>
                      </button>`
        });
      }
    } else {
      if ($('.text-columns-with-images--slider').hasClass('slick-initialized')) {
        $('.text-columns-with-images--slider').slick('unslick');
      }
    }
  }

  // Initialize slider on document ready
  initSlider();

  // Reinitialize slider on window resize
  $(window).resize(function () {
    initSlider();
  });
}); 


// document.addEventListener("DOMContentLoaded", (event) => {
//   console.log("DOM fully loaded and parsed");


//   window.removePackagingProducts =  function(){
    
//     document.querySelectorAll(".cart__remove").forEach(el => {
//       if (el.querySelectorAll("a").length > 0) {
//         el.querySelector("a").addEventListener("click", async function(e) {
//           e.preventDefault();
  
//           var removeElCurrentLink = e.currentTarget.href;
  
//           // Fetch cart data
//           const cartResponse = await fetch('/cart.js');
//           const cartData = await cartResponse.json();
  
//           // Check cart items count and item IDs
//           if (cartData.items.length <= 2 &&
//             cartData.items.some(item => ['32061619208257', '40182855761985'].includes(item.variant_id.toString()))) {
//             // Trigger click event on #minimal-packaging or #gift-wrapping, whichever is checked
//             const minimalPackagingCheckbox = document.querySelector('#minimal-packaging');
//             const giftWrappingCheckbox = document.querySelector('#gift-wrapping');
  
//             if (minimalPackagingCheckbox && minimalPackagingCheckbox.checked) {
//               setTimeout(() => {
  
//                 minimalPackagingCheckbox.click();
  
//                 setTimeout(() => {
//                   window.location.href = removeElCurrentLink;
//                 }, 500);
  
//               }, 100)
  
//             } else if (giftWrappingCheckbox && giftWrappingCheckbox.checked) {
//               setTimeout(() => {
//                 giftWrappingCheckbox.click();
//               }, 100)
  
//               setTimeout(() => {
//                 window.location.href = removeElCurrentLink;
//               }, 500);
//             }
//           }
//           else{
//             window.location.href = removeElCurrentLink;
//           }
//         });
//       }
//     });
//   }
//   window.removePackagingProducts();
// });
